import { inject, Injectable } from '@angular/core';
import { ChatSessionService } from "./chat-session.service";
import { AutomationExecutionService } from "./automation-execution.service";

@Injectable({
  providedIn: 'root'
})
export class ChatUtilitiesService {
  #chatSessionService = inject(ChatSessionService);
  #automationExecutionService = inject(AutomationExecutionService);

  /**
   * Restores the session configuration to its saved state.
   *
   * This method is used to revert configuration changes, typically after an error
   * or when cleaning up after prompt execution. It calls the AutomationExecutionService's
   * updateChatSessionConfiguration method to handle the restoration.
   *
   * @param isError If true, indicates this restoration is happening due to an error
   */
  async restoreSessionConfig(isError: boolean = false) {
    // Check if we have a session with saved configuration to restore
    const session = this.#chatSessionService.selectedSession();
    if (session && session.snapshotConfiguration) {
      // Restore the configuration using the AutomationExecutionService
      await this.#automationExecutionService.updateChatSessionConfiguration(undefined, isError);
    }
  }
}
